module.exports = __webpack_public_path__ + "static/img/s100.a71e31f1.png";